// extracted by mini-css-extract-plugin
module.exports = {"rightHeaderItem":"headerOrganism_rightHeaderItem__3R30e","header":"headerOrganism_header__2bYSy","logo":"headerOrganism_logo__3azEt","white":"headerOrganism_white__1TPnt"};